import RcForm from "rc-field-form";
import Field from "./Field";

const Form = Object.assign(RcForm, { Field: Field });

export default Form;
